import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../actions/AuthActions';
import eye from '../icons/eye.svg'
import eyehide from '../icons/eyehide.svg'

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState()
  const [showPassword, setShowPassword] = useState(false);
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  const dispatch = useDispatch()
  const auth = useSelector(state => state.user)
  const { user, userLoading, authError } = auth

  const navigate = useNavigate()
  const link = localStorage.getItem("path") || `/home?p=${33}&v=${491}&g=${8}`

  // Update error message if login fails
  useEffect(() => {
    if (authError) {
      setMessage(authError)
    }
  }, [authError])

  // Redirect when login is successful
  useEffect(() => {
    if (!userLoading && user?.id) {
      navigate(link, { replace: true })
    }
  }, [user, userLoading, navigate, link])

  const submitHandler = (e) => {
    e.preventDefault()
    if (!emailRegex.test(email)) {
      setMessage("Please, Enter Valid Email")
    } else {
      dispatch(login(email, password))
    }
  }

  if (!user && userLoading) {
    return (
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center"
           style={{background:"linear-gradient(#051932, #07294C)", padding:0, margin:0, height:"100vh"}}>
        <div className="spinner-border text-info" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  // Render login form

  if (!user && !userLoading){
    return (
        <div className="container-fluid min-vh-100 d-flex align-items-center"
             style={{background:"linear-gradient(#051932, #07294C)", padding:0, margin:0, height:"100vh"}}>
          <div className='container d-flex flex-column align-items-center justify-content-center' style={{gap:"1.5rem"}}>
            {message && <div className="col-10 col-md-8 col-lg-4 text-info text-center">{message}</div>}

            <button className="col-10 col-md-8 col-lg-4 bg-secondary fw-bold border-0 rounded py-2"
                    onClick={()=>navigate('/register', {replace:true})}>Sign Up</button>

            <input className="col-10 col-md-8 col-lg-4 p-2 border-0 rounded input"
                   type="email"
                   value={email}
                   name="email"
                   autoComplete='email'
                   placeholder="Email"
                   onChange={(e) => {setEmail(e.target.value); setMessage('')}} />

            <div className="col-10 col-md-8 col-lg-4 bg-white d-flex rounded position-relative align-items-center justify-content-between">
              <input
                className="p-2 border-0 rounded input"
                style={{ width: "90%" }}
                type={showPassword ? "text" : "password"}
                value={password}
                name="password"
                placeholder="Password"
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="position-absolute top-50 end-0 translate-middle-y me-2"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword
                  ? <img src={eyehide} alt="Hide" width="20" height="20" />
                  : <img src={eye} alt="Show" width="20" height="20" />
                }
              </span>
            </div>

            <button className="col-10 col-md-8 col-lg-4 text-primary bg-info fw-bold border-0 rounded py-2"
                    onClick={submitHandler}>Sign In</button>

            <div className="col-10 col-md-8 col-lg-4 text-center text-info fw-light text-decoration-underline"
                 role="button"
                 onClick={()=>navigate('/reset_password', {replace: true})}>
              Forgot Your Password?
            </div>
          </div>
        </div>
      )
  }

}

export default Login;
